import React, { useState } from 'react'
import expandLogo from '../../../assets/images/Expand Arrow copy.png';


const TransferToSB = (props) => {
    let { transferTo, setTransferTo, selectTo, transferToData, setExpandTo, expandTo } = props;

    const [search, setSearch] = useState('');
    
    const suggestions = transferToData && transferToData.filter((data) => {
        return data.username.toLowerCase().includes(search.toLowerCase())
    });

    const handleClick = (transferTo) => {
        setTransferTo(transferTo);
        setSearch(transferTo.username);
        setExpandTo(false);
    }

    const handleOnChange = (e) => {
        setSearch(e.target.value);
    };
    

    return (
            <div className='flex z-20 relative w-full'>
                <div className={`bg-bgColor text-fgColor px-2 py-2 w-full flex items-center justify-between rounded-sm cursor-pointer shadow-lg `}
                onClick={(e) => selectTo(e)}>
                        
                    <input 
                        type="text" 
                        className='bg-bgColor outline-none' 
                        value={search} 
                        onChange={handleOnChange} 
                        placeholder={transferTo.username} 
                    />

                    <img src={expandLogo} alt="X" className='-ml-5 w-6' onClick={()=>setSearch('')} />
                </div>
                {
                    expandTo ?
                        <div className="bg-bgColor text-fgColor w-full absolute top-[45px] cursor-pointer overflow-auto h-[210px] shadow-lg ">
                            {
                                suggestions && suggestions.map((suggestion, index) => (
                                    <div key={index}
                                        className={`${suggestion.userId !== suggestion.length ? "border-b" : "border-b-0"}  py-2
                                        px-4 hover:bg-primary hover:text-rectangle  transition-all duration-100 `}
                                        onClick={()=>handleClick(suggestion)}
                                    >
                                        {suggestion.username}
                                    </div>
                                ))
                            }
                        </div> : ""
                }
                
            </div>
    )
}

export default TransferToSB